import { RootState } from '../store'

export const filesStates = (state: RootState) => state.files
